import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx'; 

@Injectable({
  providedIn: 'root'
})
export class EntitySubmissionsService {

  constructor() { }



  private messageSubject = new Subject<any>(); 
  messageObservable = this.messageSubject.asObservable();

  setEntityEntriesTable(entityDetails:any ) {
    this.messageSubject.next(entityDetails); 
  }

  createPrefilledFile(headers: string[], fileType: string) {
    if (!headers || headers.length === 0) {
      console.error("No headers provided!");
      return;
    }
  
    // Convert headers into a 2D array (needed for Excel/CSV format)
    const data = [headers];
  
    if (fileType === 'csv') {
      // Convert data to CSV format
      const csvContent = data.map(row => row.join(",")).join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      this.downloadFile(blob, "prefilled_file.csv");
    } else if (fileType === 'xlsx' || fileType === 'xls') {
      // Convert data to Excel format
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  
      const bookType = fileType === 'xls' ? "xls" : "xlsx"; // Handle xls vs xlsx
      const excelBuffer = XLSX.write(workbook, { bookType, type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/vnd.ms-excel" });
      this.downloadFile(blob, `prefilled_file.${fileType}`);
    } else {
      console.error("Unsupported file type:", fileType);
    }
  }
  
  downloadFile(blob: Blob, filename: string) {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  mergeWidgetData(configs: any, data: any): any {
    const configMap = configs.map((config:any) => [config.widgetId, config.widgetLabel])
    
    return data.entity_values_json.map((item:any) => {
      const widgetLabel = configMap.get(item.widget_id);
      return {
        ...item,
        widget_label: item.widget_label || widgetLabel || ""
      };
    });
  }
}


